module.exports = __webpack_public_path__ + "static/media/sleep-and-relaxation@2x.3d3f1c37.png";